import type { RouteRecordRaw } from 'vue-router'
import { ScheduledRoutes, scheduledEmailIdRouteParam } from '@/routes/user/scheduled/types'
import { AppModule } from '@/config/types'
import ScheduledEmail from '@/data/models/domain/ScheduledEmail'
import ScheduledEmailRecipients from '@/data/models/domain/ScheduledEmailRecipients'

export const scheduledEditEmailRoutes: RouteRecordRaw = {
  name: ScheduledRoutes.editEmail,
  path: `scheduled/edit-email/:${scheduledEmailIdRouteParam}`,
  props: true,
  meta: {
    tabTitle: 'pageTabTitle.user.scheduled.edit',
    parent: ScheduledRoutes.scheduled,
    resolvers: [
      {
        service: 'RedirectableSingleModelResolverService',
        params: {
          model: ScheduledEmail,
          source: 'router',
          requestParam: scheduledEmailIdRouteParam,
          redirectToIfNotFound: { name: ScheduledRoutes.scheduledIndex },
          redirectToIfAccessError: { name: ScheduledRoutes.scheduledIndex },
        },
      },
      {
        service: 'SingleModelResolverService',
        params: {
          model: ScheduledEmailRecipients,
          source: 'router',
          requestParam: scheduledEmailIdRouteParam,
        },
      },
      {
        service: 'ComposeEmailResolver',
      },
    ],
    redirectToIfNotFound: { name: ScheduledRoutes.upcomingOverviewEmail },
    modules: [
      AppModule.Scheduled,
      AppModule.RRule,
      AppModule.ScheduledEdit,
      AppModule.Contacts,
      AppModule.ContactList,
      AppModule.ContactCounter,
      AppModule.SenderSettingsCountries,
      AppModule.RecentRecipient,
      AppModule.ComposeEmail,
      AppModule.FilteredViews,
      AppModule.Segments,
      AppModule.MessageSend,
      AppModule.Labels,
      AppModule.TmCodemirrorEditor,
    ],
    permission: 'scheduled',
  },
  component: () => import('@/components/views/scheduled/ScheduledEditEmail.vue'),
}
